import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import ChartFrame from "../../ChartFrame";

const TicketSessionByServiceLineGraph = ({ title, chart, chartHeight }) => {
  return (
    <ChartFrame height={chartHeight} title={title}>
      <ResponsiveContainer>
        <LineChart
          data={chart}
          margin={{
            top: 0,
            right: 10,
            left: -10,
            bottom: 15,
          }}
          isAnimationActive={false}
        >
          <CartesianGrid stroke="#ebebeb" vertical={false} />
          <XAxis
            dataKey="day"
            name="Day"
            axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }}
          />
          <YAxis axisLine={{ stroke: "var(--darkGrey)", strokeWidth: 1 }} />
          <Tooltip />
          <Legend width="100%" />
          <Line
            type="monotone"
            strokeWidth={3}
            dataKey="sessionInSeconds"
            name="Session Time"
            stroke={"var(--blue)"}
            dot={{ fill: "var(--blue)", r: 2 }}
            activeDot={{ r: 4 }}
            animationDuration={0}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartFrame>
  );
};

export default TicketSessionByServiceLineGraph;
